import { PublicClientApplication, EventType, InteractionType } from '@azure/msal-browser';

/**
 * Initialize the MSAL instance.
 */
export default async function initializeMsal(config) {
  try {
    const pca = new PublicClientApplication(config)
    await pca.initialize();

    // Set the active account if we are returning from a login redirect. This is
    // important for ensuring we are using the correct account when someone uses
    // multiple accoutns.
    pca.addEventCallback((event) => {

      const isLoginSuccess =
        event.eventType === EventType.LOGIN_SUCCESS;

      const isRedirectTokenSuccess =
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS &&
        event.interactionType === InteractionType.Redirect;

      if (isLoginSuccess || isRedirectTokenSuccess) {
        const result = event.payload;

        if (result?.account) {
          pca.setActiveAccount(result.account);
        }
      }
    });

    return pca;

  } catch (error) {
    console.error('Error initializing the authentication client: ', error);
  }
}